import React, { useState } from "react";
import { Tag, Dropdown, Menu, Tooltip } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { appHelper } from "../common/helper";

const TeamsSelector = ({
  teamsOptions,
  selectedTeams,
  onChange,
  singleSelect = false,
  formState = "",
}) => {
  const [open, setOpen] = useState(false);
  const {truncateByLength} = appHelper();

  const handleSelect = (team) => {
    if (singleSelect) {
      onChange([team]); // Replace selection
    } else if (!selectedTeams?.some((t) => t.id === team.id)) {
      onChange([...selectedTeams, team]);
    }
    setOpen(false);
  };

  const handleRemove = (teamId) => {
    if (singleSelect) {
      onChange([]); // Clear selection
    } else {
      onChange(selectedTeams.filter((team) => team.id !== teamId));
    }
  };

  const availableTeams = teamsOptions.map((team) => {
    const hasPermission =
      formState === "add"
        ? team?.permissions?.is_create
        : formState === "edit"
        ? team?.permissions?.is_update
        : true;

    return {
      ...team,
      disabled: team.disabled || !hasPermission,
    };
  });

  const menu = (
    <Menu>
      {availableTeams.length > 0 ? (
        availableTeams.map((team) => (
          <Menu.Item
            key={team.id}
            onClick={() => handleSelect(team)}
            disabled={team.disabled}
          >
            <span
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: team.color,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "8px",
              }}
            ></span>
            <Tooltip title={team.name}>
            <span>
            {truncateByLength(team.name,20)}
            </span>
            </Tooltip>
          </Menu.Item>
        ))
      ) : (
        <Menu.Item disabled style={{ color: "#999", fontStyle: "italic" }}>
          You’ve selected all available teams
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      onVisibleChange={(visible) => setOpen(visible)}
      visible={open}
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          padding: "0px 11px",
          borderRadius: "8px",
          background: "#F7F7F7",
          position: "relative",
          alignItems: "center",
          minHeight: "36px",
          cursor: "pointer",
        }}
      >
        {selectedTeams?.length === 0 && (
          <span style={{ color: "#5E5E5E", fontSize: "14px" }}>Select...</span>
        )}

        {selectedTeams.map((team) => (
          <Tag
            key={team.id}
            closable
            onClose={(e) => {
              e.stopPropagation();
              handleRemove(team.id);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "2px 4px",
              fontSize: "12px",
              fontWeight: "600",
              border: "1px solid #E2E2E2",
              backgroundColor: "#FFFFFF",
              borderRadius: "4px",
              marginInlineEnd: "0px",
            }}
          >
            <span
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: team.color,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "4px",
              }}
            ></span>
            <span
              style={{ color: "#5E5E5E", fontSize: "10px", fontWeight: "600" }}
            >
              <Tooltip title={team.name}>
                <span>
              {truncateByLength(team.name,12)}
              </span>
              </Tooltip>
            </span>
          </Tag>
        ))}

        <DownOutlined
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "12px",
            color: "#5E5E5E",
          }}
        />
      </div>
    </Dropdown>
  );
};

export default TeamsSelector;
